import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ItemOfertaData } from '../../../types';

interface PaymentFieldsProps {
  currentItem: ItemOfertaData;
  itemIndex: number;
  handleItemChange: (field: keyof ItemOfertaData, value: string | number) => void;
}

export const PaymentFields: React.FC<PaymentFieldsProps> = ({
  currentItem,
  itemIndex,
  handleItemChange,
}) => {
  return (
    <>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          id={`diasPP-${itemIndex}`}
          label="Días PP"
          fullWidth
          value={currentItem.dias_pp}
          onChange={(e) =>
            handleItemChange('dias_pp', Number(e.target.value) || 0)
          }
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          id={`descuentoPP-${itemIndex}`}
          label="Desc. PP (%)"
          fullWidth
          value={currentItem.descuento_pp}
          onChange={(e) =>
            handleItemChange('descuento_pp', Number(e.target.value) || 0)
          }
        />
      </Grid>
    </>
  );
};

